// removed by extract-text-webpack-plugin
module.exports = {"icon-button":"_1tx7Lhv7d _1s6tZE1os _3kvYUMIJc KjSy6bSLs _1jY4uEptA _2OFVW-wzu _1-ov2DQLe YXYmy67R7 _2HOZDFp6P _2_tabFk6j _1Q0mdYeBF _3v9QXXXDN _3BiTzCAU- _3uKzqKb8t OSBVy-e59 _3ugGu5boG _1yJuXbiru _20rWKo4VQ _13qojEuKg _1BE2U7F8v","label":"_2fVvb-Ocd _1jY4uEptA _2r1vMEdE0","icon":"_2stFSDbPy _3BXwjRVJc _3J1KksQN0 _2-G_dCT1T _2QmiN2YWU _34YKmqAjT qigzzAbil"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/icon-button/icon-button.css
 ** module id = 2136
 ** module chunks = 0
 **/